import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const rankTrackerFutureConfig: RouterStateConfig = {
    "ranktracker.**": {
        url: "/digitalsuite/rank-tracker",
        lazyLoad: () => import("single-spa/react-app/config/solutions25/campaigns/rankTrackerConfig"),
    },
};
